import { usePageTitle } from 'utils/pageTitle';

import DashboardLayout from 'pages/_rd_dashboard/DashboardLayout';
import PortfolioCalendar from 'pages/_rd_dashboard/PortfolioCalendar';

 
import './Compliance.css';

const Compliance = (props) => {
	usePageTitle('Compliance');

	return (
		<DashboardLayout>
			<div className="dashboard-compliance">
				<div className="dashboard-section">
					<div className="dashboard-section-header">
						<h1><i className={'bi bi-calendar4-week me-3'} />Compliance</h1>
					</div>
					<div className="dashboard-section-body">
						<PortfolioCalendar />
					</div>
				</div>
			</div>
		</DashboardLayout>
	);
}

export default Compliance;
